import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import DataBox from "components/databox";
import TextAreaDataBox from "components/textAreaDataBox.js";

const ViewModal = ({ isOpen, onClose, data }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent
        minH={"300px"}
        minW={"800px"}
        p={3}
        py={6}
        borderRadius={"16px"}
      >
        <ModalBody display={"flex"} flexDirection={"column"} gap={5}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            Items Donated To Charity
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Details
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={4}
            >
              <DataBox
                label={"SKU"}
                data={data?.variants?.sku}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
              <DataBox
                label={"Product Title"}
                data={data?.product_title}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
              <DataBox
                label={"Charity you Chosen"}
                data={data?.charity?.name}
                containerStyles={{
                  minHeight: "48px",
                }}
              />
              <TextAreaDataBox
                label={"Reason for Rejection"}
                data={data?.variants?.instances?.rejection_reason}
              />
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              fontSize="12px"
              borderRadius="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewModal;
